(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-expire', {
            parent: 'application',
            url: '/password-expire?days',
            data: {
                pageTitle: 'global.menu.password-expire'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password-expire/password-expire.html',
                    controller: 'PasswordExpireController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('password-expire');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
